import IconButton from "@mui/material/IconButton"
import Image from "next/image"
import React from "react"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()({
  image: {
    height: "40px",
    width: "40px",
    borderRadius: "20px",
    position: "relative",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    justifyContent: "right",
  },
})

interface ISocialProfile {
  profileUrlLabel: string
  socialLink: string
  socialIcon: string
}

const SocialProfile = (props: ISocialProfile) => {
  const { profileUrlLabel, socialLink, socialIcon } = props
  const { classes } = useStyles()

  return (
    <IconButton aria-label={profileUrlLabel} href={socialLink} target="_blank" size="large">
      <div className={classes.image}>
        <Image src={socialIcon} layout="fill" alt={`Icon for ${profileUrlLabel}`} />
      </div>
    </IconButton>
  )
}
export default SocialProfile
